<template>

    <div class="layout__padding-clear">

        <div class="text__align-center text__colour-white layout__margin__bottom-25px">
            <div class="layout__padding-clear layout__width-50 layout__padding-40px-0 layout__border__bottom-light-teal-1px">
                <h2 class="text__colour-teal">Get a Price</h2>
                <div class="layout__padding-20-0 text__size-18 text__colour-grey">Fill in a few quick details and receive an instant price, valid for 30 days</div>
            </div>
        </div>
        <div class="layout__padding-clear layout__width-800px">
            <Stepguide v-bind:stepCount="1"></Stepguide>
            <h3 class="text__colour-teal text__align-center layout__padding-20-0">Select details</h3>
        </div>

        <div class="layout__width-80 layout__padding-clear">
            <div class="component__columns-2">
                <p class="layout__padding-8-0">Fold Style</p>

                <el-radio-group v-model="quoteJob.printJobSpec.fCode" :max="1" class="layout__padding-clear layout__width-100" v-on:change="postProduct">
                        <el-radio-button v-for="(product) in products" class="layout__width-200px layout__margin-10-0 layout__border__all-2px-f4f4f4 layout__margin-10px-10px-10px-0px" :label="product.code" :key="product" :value="product">
                            <img class="layout__height-100px layout__width-100px layout__padding-20-0" v-bind:src="product.pictureSmall">
                            <p class="layout__padding-10px-0">{{product.name}}</p>
                        </el-radio-button>
                </el-radio-group>
            </div>

            <div class="component__columns-2">
                <div class="">
                    <div class="">
                        <div class="layout__width-100">
                            <p class="layout__padding-8-0">Paper Type</p>
                            <el-select v-model="orderSummary.type" clearable filterable
                                       placeholder="Select style"
                                       v-on:change="postPaperType"
                            :disabled="quoteJob.printJobSpec.fCode === null">
                                <el-option
                                        v-for="type in types"
                                        :key="type"
                                        :label="type"
                                        :value="type">
                                    <span v-if="type === 'LF23'">DURATRAN</span>
                                    <span v-else>{{type}}</span>
                                </el-option>
                            </el-select>
                        </div>

                        <div class="layout__width-100 layout__margin__top-30">
                            <p class="layout__padding-8-0">Paper Weight</p>
                            <el-select v-model="orderSummary.weight" clearable filterable
                                       placeholder="Select paper weight" v-on:change="postPaperWeight" :disabled="(quoteJob.printJobSpec.fCode === null && quoteJob.printJobSpec.stockWeight === null) || disableSelections">
                                <el-option
                                        v-for="weight in weights"
                                        :key="weight"
                                        :label="weight"
                                        :value="weight">
                                                <span>
                                                    <span v-if="weight === 'LF23'">DURATRAN</span>
                                                    <span v-if="weight === 'INTRAN'">INTRAN</span>
                                                    <span v-if="weight === 'TRU'">TRUCARD</span>
                                                    <span v-if="weight !== 'INTRAN' && weight !== 'LF23' && weight !== 'TRU'">{{weight}}</span>
                                                    <span v-if="weight !== 'INTRAN' && weight !== 'LF23' && weight !== 'TRU'">gsm</span>
                                                </span>
                                </el-option>
                            </el-select>
                        </div>

                        <div class="layout__width-100 layout__margin__top-30">
                            <p class="layout__padding-8-0">Lamination</p>
                            <el-select v-model="orderSummary.lamination" clearable filterable
                                       placeholder="Select Lamination" v-on:change="postLamination" :disabled="(quoteJob.printJobSpec.fCode === null && quoteJob.printJobSpec.stockWeight === null && quoteJob.printJobSpec.productRef === null) || disableSelections">
                                <el-option
                                        v-for="lamination in laminations"
                                        :label="lamination.finishing"
                                        :key="lamination.finishing"
                                        :value="lamination.finishing">
                                    <div class="layout__width-250px"
                                         v-show="lamination.finishing == 'STANDARD' || lamination.finishing == '' || lamination.finishing === 'NONE' || lamination.finishing === 'SILK'">
                                        No Lamination
                                    </div>
                                    <div class="layout__width-250px" v-show="lamination.finishing == 'MATT LAM'">
                                        Matt Lamination
                                    </div>
                                    <div class="layout__width-250px" v-show="lamination.finishing == 'GLOSS LAM'">
                                        Gloss Lamination
                                    </div>
                                </el-option>
                            </el-select>
                        </div>

                        <div class="layout__width-100 layout__margin__top-30">
                            <p class="layout__padding-8-0">Quantity</p>
                            <el-form :model="quoteJob.printJobSpec.quantity" status-icon :rules="rules"
                                     ref="quoteJob.printJobSpec.quantity" class="paddingInput">
                                <el-form-item prop="quantity" class="teal">
                                    <el-input class="" placeholder="Enter a quantity"
                                              v-model="quoteJob.printJobSpec.quantity" clearable
                                              :disabled="!(quoteJob.printJobSpec.lamination && quoteJob.printJobSpec.stockType && quoteJob.printJobSpec.stockWeight)"
                                              v-on:blur="postQuantity()"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>

            <div class="text__align-center layout__padding-clear layout__padding-20-0">
                <el-button class="button__base button-teal layout__width-200px layout__margin__right-20px"
                           v-on:click="newQuote()">
                    Start again
                </el-button>
                <el-button class="button__base button-red layout__width-200px"
                           :disabled="completedOrder"
                           v-on:click="confirmation()">
                    Get a price
                </el-button>
            </div>
        </div>

    </div>

</template>

<script>

    import Axios from 'axios';
    import Router from '../../../router';
    import {axios} from '@/mixins/Axios.js';
    import Stepguide from "../../../components/tools/quote/StepGuide";

    export default {
        name: "quoteSelection",
        mixins: [axios],
        props: {
            quoteJob: Object,
            products: Array
        },
        components: {
            Stepguide
        },
        computed: {
            completedOrder() {
                if (this.quoteJob.printJobSpec.stockWeight !== null && this.quoteJob.printJobSpec.productRef !== null && this.quoteJob.printJobSpec.lamination !== null && this.quoteJob.printJobSpec.quantity > 0) {
                    return false
                } else {
                    return true
                }
            }
        },
        data() {
            const validateQuantity = (rule, value, callback) => {
                if (this.quoteJob.printJobSpec.quantity < this.minQuantity) {
                    callback(new Error('Quantity must be over the minimum quantity of ' + this.minQuantity + ' for this product'));
                } else {
                    callback();
                }
            };
            return {
                disableSelections: false,
                selectedProduct: {},
                generationDate: new Date().toLocaleDateString('en-GB') + ' ' + new Date().toLocaleTimeString('en-GB'),
                weights: [],
                types: [],
                laminations: [],
                quantities: [],
                orderSummary: {
                },
                minQuantity: 0,
                jobReference: '',
                weight: true,
                lamination: false,
                quantity: false,
                rules: {
                    quantity: [{
                        message: '',
                        trigger: 'blur'
                    },
                        {
                            validator: validateQuantity
                        }],
                }
            }
        },
        // computed: {
        //     lamination() {
        //         return this.quoteJob.printJobSpec.lamination;
        //     }
        // },
        created() {

            if (typeof this.quoteJob === 'undefined') {
                this.quoteJob = JSON.parse(window.sessionStorage.getItem('_quoteJob'))
                console.log(this.quoteJob)
            }

            if (typeof this.products === 'undefined') {
                this.products = JSON.parse(window.sessionStorage.getItem('_quoteProducts'))
                console.log(this.products.length)
            }


            if (this.products.length === 1) {
                this.postProduct(this.products[0].code)
            }



            if (window.sessionStorage.getItem('_quoteSummary') !== null) {
                this.orderSummary = JSON.parse(window.sessionStorage.getItem('_quoteSummary'))
            } else {
                this.orderSummary = {

                }
            }

            // console.log('selected product')
            // console.log('selected product object ', this.selectedProduct)
            // console.log('selected product sessionStorage ', JSON.parse(window.sessionStorage.getItem('_selectedProduct')))


            console.log()


            if (JSON.parse(window.sessionStorage.getItem('_selectedProduct')) != null) {
                this.selectedProduct = JSON.parse(window.sessionStorage.getItem('_selectedProduct'))
            }
            //
            // console.log('getting types')

            if (this.quoteJob.printJobSpec.fCode !== null) {
                this.getPaperTypes()
            }
            //
            if (this.quoteJob.printJobSpec.stockType !== null) {
                this.getPaperWeights()
            }

            if (this.quoteJob.printJobSpec.stockWeight !== null && this.quoteJob.printJobSpec.stockType !== null) {
                this.getLaminations()
            }

            if (this.quoteJob.printJobSpec.stockWeight !== null && this.quoteJob.printJobSpec.stockType !== null && this.quoteJob.printJobSpec.lamination !== null) {
                this.getQuantities()
            }


        },
        beforeUpdate() {
            window.sessionStorage.setItem('_quoteJob', JSON.stringify(this.quoteJob));
            window.sessionStorage.setItem('_quoteSummary', JSON.stringify(this.orderSummary));
            // window.sessionStorage.setItem('_selectedProduct', JSON.stringify(this.selectedProduct));
        },
        methods: {
            getPaperTypes() {
                const urlStockType = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/Catalogue/FindStockTypeAsync`

                const getTypes = {
                    "id": 0,
                    "fCode": this.quoteJob.printJobSpec.fCode,
                    "stockType": "string",
                    "pageWidth": 0,
                    "pageHeight": 0,
                    "actualPageWidth": 0,
                    "actualPageHeight": 0,
                    "pageOrientation": "string",
                    "stockWeight": "string",
                    "lamination": "string",
                    "pageCount": 0,
                    "quantity": 0
                }

                console.log(getTypes)

                Axios.post(urlStockType, getTypes, this.returnHeaderNoToken())
                    .then(response => {
                        console.log(response)
                        this.types = response.data
                        // if (this.types.length === 0) {
                        // }
                    })
            },
            getPaperWeights() {
                const urlWeights = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/Catalogue/FindStockWeightAsync`

                const getWeights = {
                    "id": 0,
                    "fCode": this.quoteJob.printJobSpec.fCode,
                    "stockType": this.quoteJob.printJobSpec.stockType,
                    "pageWidth": 0,
                    "pageHeight": 0,
                    "actualPageWidth": 0,
                    "actualPageHeight": 0,
                    "pageOrientation": "string",
                    "stockWeight": "string",
                    "lamination": "string",
                    "pageCount": 0,
                    "quantity": 0
                }

                Axios.post(urlWeights, getWeights, this.returnHeaderNoToken())
                    .then(response => {
                        console.log('weight response from created ' + response)
                        this.weights = response.data
                        console.log(this.weights)
                        // if (this.weights.length === 0) {
                        // }
                    })
            },
            getLaminations() {
                const urlLaminations = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/Catalogue/FindLaminate`

                const getLaminations = {
                    "id": 0,
                    "fCode": this.quoteJob.printJobSpec.fCode,
                    "stockType": this.quoteJob.printJobSpec.stockType,
                    "pageWidth": 0,
                    "pageHeight": 0,
                    "actualPageWidth": 0,
                    "actualPageHeight": 0,
                    "pageOrientation": "string",
                    "stockWeight": this.quoteJob.printJobSpec.stockWeight,
                    "lamination": "string",
                    "pageCount": 0,
                    "quantity": 0
                }

                Axios.post(urlLaminations, getLaminations, this.returnHeaderNoToken())
                    .then(response => {
                        console.log(response)
                        this.laminations = response.data
                    })
            },
            getQuantities() {

                console.log('*************************** get min qty')
                const urlQuantities = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/Catalogue/FindMinimumQuantity`

                const getQuantities = {
                    "id": 0,
                    "fCode": "string",
                    "stockType": "string",
                    "pageWidth": 0,
                    "pageHeight": 0,
                    "actualPageWidth": 0,
                    "actualPageHeight": 0,
                    "pageOrientation": "string",
                    "stockWeight": 0,
                    "productRef": this.quoteJob.printJobSpec.productRef,
                    "lamination": "string",
                    "pageCount": 0,
                    "quantity": 0
                }

                console.log(urlQuantities);

                console.log(getQuantities);

                Axios.post(urlQuantities, getQuantities, this.returnHeaderNoToken())
                    .then(response => {
                        this.minQuantity = response.data
                        this.filterQuantity()
                    })
            },
            postPaperType(type) {


                switch (type) {
                    case 'LF23':
                        this.orderSummary.type = 'DURATRAN'
                        this.orderSummary.weight = 'DURATRAN'
                        this.orderSummary.lamination = 'NO LAMINATION'
                        break;
                    case 'INTRAN':
                        this.orderSummary.type = 'INTRAN'
                        this.orderSummary.weight = 'INTRAN'
                        this.orderSummary.lamination = 'NO LAMINATION'
                        break;
                    case 'TRU':
                        this.orderSummary.type = 'TRUCARD'
                        this.orderSummary.weight = 'TRUCARD'
                        this.orderSummary.lamination = 'NO LAMINATION'
                        break;
                    default:
                        this.orderSummary.type = type
                        this.orderSummary.weight = ''
                        this.orderSummary.lamination = ''
                }

                console.log('type ' + type)

                this.quoteJob.printJobSpec.stockType = type

                const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/quotes/` + this.quoteJob.id + '?resetJobSpec=true'

                const selectTypes = {
                    "printJobSpec": {
                        "stockType": this.quoteJob.printJobSpec.stockType,
                    }
                }

                Axios.put(url, selectTypes)
                    .then(response => {
                        console.log(response)
                        this.weights = []
                        this.laminations = []
                        this.quantities = []
                        this.quoteJob = response.data

                        if (this.quoteJob.printJobSpec.stockType !== 'LF23' && this.quoteJob.printJobSpec.stockType !== 'INTRAN' && this.quoteJob.printJobSpec.stockType !== 'TRU') {
                            // todo do normal get the weight and show weight
                            this.disableSelections = false;
                            this.getPaperWeights()
                        } else {
                            // todo move straight to quantity and disable others x2
                            this.getQuantities()
                            this.disableSelections = true;
                        }
                    })
            },
            postPaperWeight() {
                console.log('select weight')
                const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/quotes/` + this.quoteJob.id

                const selectWeight = {
                    "printJobSpec": {
                        "stockWeight": this.orderSummary.weight,
                    }
                }

                // this.orderSummary.weight

                console.log('weight')

                console.log(url)
                console.log(selectWeight)

                Axios.put(url, selectWeight)
                    .then(response => {
                        this.quantities = []
                        // this.completedOrder = true
                        this.quoteJob = response.data

                        const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/Catalogue/FindLaminate`

                        const getLaminations = {
                            "id": 0,
                            "fCode": this.quoteJob.printJobSpec.fCode,
                            "stockType": this.quoteJob.printJobSpec.stockType,
                            "pageWidth": 0,
                            "pageHeight": 0,
                            "actualPageWidth": 0,
                            "actualPageHeight": 0,
                            "pageOrientation": "string",
                            "stockWeight": this.quoteJob.printJobSpec.stockWeight,
                            "lamination": "string",
                            "pageCount": 0,
                            "quantity": 0
                        }

                        Axios.post(url, getLaminations, this.returnHeaderNoToken())
                            .then(response => {
                                this.laminations = []
                                console.log(response.data)
                                this.laminations = response.data

                            })
                            .catch(error => {
                                // if (error.response.status === 500) {
                                // }
                            })
                    })
            },
            postLamination(row) {
                let currentSelection = {}

                this.laminations.find(function(element) {
                    console.log(element.finishing === row)
                    if (element.finishing === row) {
                        currentSelection = element
                    }

                })

                console.log(currentSelection)

                const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/quotes/` + this.quoteJob.id

                console.log(url)

                switch (row) {
                    case 'GLOSS LAM':
                        this.orderSummary.lamination = 'GLOSS LAMINATION'
                        break;
                    case 'MATT LAM':
                        this.orderSummary.lamination = 'MATT LAMINATION'
                        break;
                    case 'VELVET LAM':
                        this.orderSummary.lamination = 'VELVET LAMINATION'
                        break;
                    default:
                        this.orderSummary.lamination = 'NO LAMINATION'
                }


                const selectLamination = {
                    "printJobSpec": {
                        "lamination": currentSelection.finishing,
                        "productRef": currentSelection.productRef
                    }
                }

                console.log('laminations')
                console.log(selectLamination)

                Axios.put(url, selectLamination)
                    .then(response => {
                        this.quoteJob = response.data
                        this.getQuantities()
                    })
            },
            postQuantity() {
                console.log('select quantities')

                console.log('JOB')
                console.log(this.quoteJob)

                if (this.quoteJob.printJobSpec.quantity >= this.minQuantity) {

                    const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/quotes/` + this.quoteJob.id
                    console.log(url)

                    const selectQuantity = {
                        "printJobSpec": {
                            "quantity": Number(this.quoteJob.printJobSpec.quantity),
                        }
                    }

                    console.log(selectQuantity)

                    Axios.put(url, selectQuantity)
                        .then(response => {
                            console.log(response)
                            this.quoteJob = response.data

                            this.quoteJob.netUnitPrice = this.formatCurrencyTwoPlaces(this.quoteJob.netUnitPrice)
                            this.quoteJob.netTotalOfflinePrice = this.formatCurrencyTwoPlaces(this.quoteJob.netTotalOfflinePrice)
                            this.quoteJob.netTotalPrice = this.formatCurrencyTwoPlaces(this.quoteJob.netTotalPrice)
                        })
                        .catch(error => {
                            // if (error.response.status === 500) {
                            // }
                        })
                }
            },
            filterQuantity() {
                const filteringQuantities = [
                    '1',
                    '2',
                    '5',
                    '10',
                    '16',
                    '30',
                    '40',
                    '50',
                    '60',
                    '70',
                    '80',
                    '90',
                    '100',
                    // '250',
                    // '500',
                    // '750',
                    // '1000',
                    // '2500'
                ]

                this.quantities = []

                filteringQuantities.forEach(quantity => {
                    if (quantity >= this.minQuantity) {
                        this.quantities.push(quantity)
                    }
                })
            },
            formatCurrencyTwoPlaces(currency) {
                currency.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                console.log('£' + parseFloat(currency).toFixed(2))
                return '£' + parseFloat(currency).toFixed(2);
            },
            newQuote() {
                this.orderSummary = {}
                window.sessionStorage.removeItem('_selectedProduct')
                window.sessionStorage.removeItem('_quoteProducts')
                window.sessionStorage.removeItem('_quoteSummary')
                window.sessionStorage.removeItem('_quoteJob')
                Router.push({
                    name: '/get-price/products'
                });
            },
            postProduct(row) {
                console.log('selectedProudct ', row)
                this.orderSummary = {}
                window.sessionStorage.removeItem('_quoteSummary')
                console.log('printing the results from the example method')
                console.log(row)

                let productMatch = {}

                this.products.find(function(element) {
                    console.log(element.code === row)
                    if (element.code === row) {
                        console.log('product MATCHED')
                        productMatch = element
                    }

                    })

                this.selectedProduct = productMatch

                console.log(this.selectedProduct)

                const selectProduct = {
                    "printJobSpec": {
                        "fCode": this.selectedProduct.code,
                        "name": this.selectedProduct.name,
                        "description": this.selectedProduct.description,
                        "pageWidth": this.quoteJob.printJobSpec.pageWidth,
                        "pageHeight": this.quoteJob.printJobSpec.pageHeight,
                        "pageCount": this.quoteJob.printJobSpec.pageCount
                    }
                }

                let selectedProduct = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/quotes/` + this.quoteJob.id
                console.log('SELECT PRODUCT')
                console.log(selectProduct)

                Axios.put(selectedProduct, selectProduct)
                    .then(response => {
                        console.log(response)
                        this.quoteJob = response.data
                        window.sessionStorage.setItem('_selectedProduct', JSON.stringify(this.selectedProduct));
                        this.getPaperTypes()
                    })
            },
            // selectProduct(product) {
            //     console.log('selecting products')
            //     console.log(product)
            //
            //     let selectedProduct = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/quotes/` + this.quoteJob.id
            //
            //     console.log(selectedProduct)
            //
            //     const selectProduct = {
            //         "printJobSpec": {
            //             "fCode": product.code,
            //             "name": product.name,
            //             "description": product.description,
            //             "pageWidth": this.quoteJob.printJobSpec.pageWidth,
            //             "pageHeight": this.quoteJob.printJobSpec.pageHeight,
            //             "pageCount": this.quoteJob.printJobSpec.pageCount
            //         }
            //     }
            //     console.log('SELECT PRODUCT')
            //     console.log(selectProduct)
            //
            //     Axios.put(selectedProduct, selectProduct)
            //         .then(response => {
            //             console.log(response)
            //             this.quoteJob = response.data
            //         })
            // },
            confirmation() {
                console.log('selected product')
                console.log(this.selectedProduct)

                console.log('select quantities')

                console.log('JOB')
                console.log(this.quoteJob)

                if (this.quoteJob.printJobSpec.quantity >= this.minQuantity) {

                    const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/quotes/` + this.quoteJob.id
                    console.log(url)

                    const selectQuantity = {
                        "printJobSpec": {
                            "quantity": Number(this.quoteJob.printJobSpec.quantity),
                        }
                    }

                    console.log(selectQuantity)

                    Axios.put(url, selectQuantity)
                        .then(response => {
                            console.log(response)
                            this.quoteJob = response.data

                            this.quoteJob.netUnitPrice = this.formatCurrencyTwoPlaces(this.quoteJob.netUnitPrice)
                            this.quoteJob.netTotalOfflinePrice = this.formatCurrencyTwoPlaces(this.quoteJob.netTotalOfflinePrice)
                            this.quoteJob.netTotalPrice = this.formatCurrencyTwoPlaces(this.quoteJob.netTotalPrice)

                            console.log('selectedProduct ', this.selectedProduct)


                            Router.push({
                                name: '/get-price/confirmation',
                                params: {
                                    quoteJob: this.quoteJob,
                                    selectedProduct: this.selectedProduct,
                                    products: this.products
                                }
                            });
                        })
                        .catch(error => {
                            // if (error.response.status === 500) {
                            // }
                        })
                }



            }
        }
    };
</script>
